import { render, staticRenderFns } from "./PrivacyDdayCount.vue?vue&type=template&id=31acfa73&scoped=true"
import script from "./PrivacyDdayCount.vue?vue&type=script&lang=js"
export * from "./PrivacyDdayCount.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDdayCount.vue?vue&type=style&index=0&id=31acfa73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31acfa73",
  null
  
)

export default component.exports